import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SupplierForm from '../../../components/Suppliers/SupplierForm';
import Toast from '../../../components/Common/Toast';

const CreateVentasClient = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo Cliente</h1>
          <p className="text-gray-600 mt-1">Registre una entidad como cliente para el módulo de Ventas</p>
        </div>
        <SupplierForm
          isPageMode
          forceClientOnly
          onSuccess={() => {
            setToast({ isOpen: true, message: 'Cliente creado exitosamente', type: 'success' });
            setTimeout(() => navigate('/ventas/clients'), 1500);
          }}
          onError={(error) => {
            setToast({
              isOpen: true,
              message: error.response?.data?.message || 'Error al crear cliente',
              type: 'error',
            });
          }}
        />
      </div>
      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast((t) => ({ ...t, isOpen: false }))}
      />
    </div>
  );
};

export default CreateVentasClient;
